class MiniCart extends HTMLElement {
  constructor() {
    super();
    this.isUpdating = false;
    this.bindEvents();
  }
  
  bindEvents() {
    if(document.querySelector("#minicart-drawer-toggle")){
      document.querySelector("#minicart-drawer-toggle").addEventListener('click', this.openDrawer.bind(this))
    }
    this.querySelectorAll('[data-sideDrawer-close]').forEach((button) =>
      button.addEventListener('click', this.closeDrawer.bind(this))
    );
  }
  
  openDrawer(event) {
    event.preventDefault();
    this.isUpdating = true;
    
    fetch(this.dataset.url)
      .then(response => response.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        
        const cartDrawerElement = doc.querySelector('cart-drawer');
        
        if (cartDrawerElement) {
          const minicartElement = document.getElementById('minicart');
          minicartElement.innerHTML = cartDrawerElement.innerHTML;
          
          const miniCartInner = minicartElement.querySelector('mini-cart');
          if (miniCartInner) {
            miniCartInner.removeAttribute('data-cart-count');
          }
        }
        
        if(document.querySelector("#cart-upsell-product")){
          themeSlidersInit($("#cart-upsell-product"));
        }
        
        document.querySelector("#minicart").classList.add("active");
        document.querySelector("body").classList.add("no-scroll");

        this.bindCloseEvents();
        
        setTimeout(() => {
          trapFocusElements(document.querySelector("#minicart"))
          this.isUpdating = false;
        }, 500)
        
        setTimeout(() => {
          fetch("/cart.js")
            .then(response => response.json())
            .then((data) => {
              let totalprice = data.total_price;
              shippingProgressBar(totalprice)
            })
        }, 500)
      })
      .catch(e => {
        console.error(e);
        this.isUpdating = false;
      });
  }
  
  bindCloseEvents() {
    this.querySelectorAll('[data-sideDrawer-close]').forEach((button) =>
      button.addEventListener('click', this.closeDrawer.bind(this))
    );
  }
  
  renderContents(parsedState) {
    if (this.isUpdating) {
      console.log('Skipping renderContents during initial load');
      return;
    }
    
    this.getSectionsToRender().forEach((section => {
      if (document.getElementById(section.id)) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(parsedState.sections[section.id], 'text/html');
        const cartDrawerElement = doc.querySelector('cart-drawer');
        
        if (cartDrawerElement) {
          const targetElement = document.querySelector(section.selector);
          if (targetElement) {
            targetElement.innerHTML = cartDrawerElement.innerHTML;
            
            const miniCartInner = targetElement.querySelector('mini-cart');
            if (miniCartInner) {
              miniCartInner.removeAttribute('data-cart-count');
            }
          }
        }
        
        if(document.querySelector("#cart-upsell-product")){
          themeSlidersInit($("#cart-upsell-product"));
        }

        let totalCount = doc.querySelector("mini-cart")?.getAttribute("data-cart-count") || "0";
        
        if(document.querySelector("[data-header-cart-count]")){
          const headerCount = document.querySelector("[data-header-cart-count]");
          
          if(headerCount.classList.contains("hidden")){
            headerCount.classList.remove("hidden")
          }
          
          if(totalCount == 0){
            headerCount.classList.add("hidden")
          }
          else if(totalCount < 100){
            headerCount.textContent = totalCount;
          } else {
            headerCount.textContent = '';
          }
        }

        this.bindCloseEvents();
      }
    }));
    
    setTimeout(() => {
      fetch("/cart.js")
        .then(response => response.json())
        .then((data) => {
          let totalprice = data.total_price;
          shippingProgressBar(totalprice)
        })
    }, 500)
  }
  
  getSectionsToRender() {
    return [
      {
        id: 'mini-cart',
        section: 'cart-drawer',
        selector: 'cart-drawer'
      }
    ];
  }
  
  getSectionInnerHTML(html, selector = 'cart-drawer') {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    const element = doc.querySelector(selector);
    return element ? element.innerHTML : '';
  }
  
  closeDrawer(event){
    event.preventDefault();
    const closeElement = event.currentTarget;
    if(closeElement.closest(".side-drawer-panel").classList.contains("active")){
      closeElement.closest(".side-drawer-panel").classList.remove("active");
      document.querySelector("body").classList.remove("no-scroll");
    }
  }
}

customElements.define('cart-drawer', MiniCart);

(() => {
  if (window.CimoSamiNativeCart) return;

  const selector = 'cart-drawer#minicart';
  const states = new WeakMap();
  const observers = new Map();
  let scheduled = false;
  let notifications = 0;

  function mark(element, attribute) {
    if (element && !element.hasAttribute(attribute)) {
      element.setAttribute(attribute, '');
    }
  }

  function mapDrawer(drawer) {
    const rows = Array.from(drawer.querySelectorAll('.cart-product-item[data-cart-item]'));
    const form = drawer.querySelector('form.form-minicart');
    const checkout = drawer.querySelector('#checkoutCart[name="checkout"]');
    const previous = states.get(drawer);
    const changed = !previous || previous.form !== form || previous.checkout !== checkout ||
      previous.rows.length !== rows.length || rows.some((row, index) => row !== previous.rows[index]);
    if (!changed) return false;

    mark(drawer, 'samitaWS-drawer-form');
    rows.forEach((row) => {
      row.classList.add('samitaWS-drawer-line-item-key');
      const detail = row.querySelector('.cart-product-detail');
      if (detail) {
        const price = detail.querySelector('.cart-final-price') ||
          detail.querySelector(':scope > .item-price');
        const unit = price && (price.matches('.item-price') ? price : price.querySelector('.item-price'));
        mark(price, 'samitaWS-drawer-product-main-price');
        mark(unit, 'samitaWS-drawer-line-item-unit-price');
      }
      mark(row.querySelector('quantity-input'), 'samitaWS-drawer-line-item-qty-wrapper');
      mark(row.querySelector('input.quantity__input'), 'samitaWS-drawer-line-item-qty');
      mark(row.querySelector('button[name="minus"]'), 'samitaWS-drawer-line-item-qty-decrease');
      mark(row.querySelector('button[name="plus"]'), 'samitaWS-drawer-line-item-qty-increase');
      mark(row.querySelector('a[data-remove-item]'), 'samitaWS-drawer-line-item-remove-button');
    });
    mark(drawer.querySelector('.cart-total-box > li:last-child > .textXLarge'),
      'samitaWS-drawer-line-item-subtotal-price');
    mark(checkout, 'samitaWS-drawer-checkout-btn');
    states.set(drawer, { form, checkout, rows });
    return true;
  }

  function scan() {
    scheduled = false;
    let changed = false;
    for (const [drawer, observer] of observers) {
      if (!drawer.isConnected) {
        observer.disconnect();
        observers.delete(drawer);
      }
    }
    document.querySelectorAll(selector).forEach((drawer) => {
      if (!observers.has(drawer)) {
        const observer = new MutationObserver(schedule);
        observer.observe(drawer, { childList: true, subtree: true });
        observers.set(drawer, observer);
      }
      changed = mapDrawer(drawer) || changed;
    });
    if (changed) {
      notifications += 1;
      document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
    }
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    queueMicrotask(scan);
  }

  window.CimoSamiNativeCart = Object.freeze({
    version: '1.0.0',
    inspect() {
      const drawer = document.querySelector(selector);
      return {
        version: this.version,
        notifications,
        drawerMapped: Boolean(drawer && drawer.hasAttribute('samitaWS-drawer-form')),
        rowsMapped: drawer ? drawer.querySelectorAll('.samitaWS-drawer-line-item-key').length : 0,
        checkoutMapped: Boolean(drawer && drawer.querySelector('[samitaWS-drawer-checkout-btn]'))
      };
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule, { once: true });
  } else {
    schedule();
  }
  document.addEventListener('shopify:section:load', schedule);
  window.addEventListener('pageshow', schedule);
})();
